export default {"src":"/_next/static/media/hazelnuts.debe3bde.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};